import { Event } from '../types/event';

/**
 * Check if an event has ended (active status but past event date)
 * @param event - The event to check
 * @returns true if event has ended, false otherwise
 */
export const hasEventEnded = (event: Event): boolean => {
  if (!event || !event.event_date || !event.event_time) {
    return false;
  }
  
  // Check if status is active
  if (event.status !== 'active') {
    return false;
  }
  
  // Check if event date/time has passed
  const eventDate = new Date(`${event.event_date}T${event.event_time}`);
  return eventDate < new Date();
};

/**
 * Check if an event date has passed (regardless of status)
 * @param event - The event to check
 * @returns true if event date has passed, false otherwise
 */
export const isEventPast = (event: Event): boolean => {
  if (!event || !event.event_date || !event.event_time) {
    return false;
  }
  
  const eventDate = new Date(`${event.event_date}T${event.event_time}`);
  return eventDate < new Date();
};

/**
 * Check if an event can be edited (checks both editing window and ended status)
 * @param event - The event to check
 * @returns true if event can be edited, false otherwise
 */
export const canEditEvent = (event: Event): boolean => {
  if (!event) return false;
  if (!event.can_edit_event) return false;
  if (hasEventEnded(event)) return false;
  return true;
};

